<div *ngIf="showSpinner" class="spinner-wrapper">
    <mat-spinner class="spinner-inner"></mat-spinner>
</div>

<div *ngIf="!showSpinner" class="main-wrapper">

    <div class="welcome-header">
        <div class="welcome-header-title">
            <p>{{ 'text.welcome_title' | translate }}</p>
        </div>
        <div class="welcome-header-subtitle">
            <p>{{ 'text.welcome_intro_text' | translate }}</p>
        </div>
    </div>

    <div *ngIf="!showNoStudentMessage" class="student-avatar-grid">
        <div *ngFor="let student of students">

            <div class="student-avatar" style="background-image: url({{student['primary_photo']}});"
                (click)="redirectTo('/student/'+ relationshipIdList[student.id] )"></div>
            <div class="student-avatar-caption">
                <span>{{ student['name'] }}</span>
                <span>{{ student['stage_name']}} / {{ student['yearperiod_name'] }}</span>
            </div>
        </div>
    </div>

    <div *ngIf="!showNoReportageMessage" class="student-avatar-grid">
        <div *ngFor="let reportage of reportages">

            <div class="student-avatar" style="background-image: url({{reportage['reportage_image']}});"
                (click)="redirectTo('/reportagephoto/'+ reportage['id'] )"></div>
            <div class="student-avatar-caption">
                <span>{{ reportage['name'] }}</span>
                <span>{{ reportage['yearperiod_name'] }}</span>
            </div>
        </div>
    </div>

    <div *ngIf="showNoStudentMessage && showNoReportageMessage" class="no-student-msg-wrapper">
        <p style="font-size: 16px">{{ 'text.no_students_associated' | translate }}.</p>
    </div>

    <div style="text-align: center;">
        <button mat-raised-button color="primary" aria-label="add son" style="background-color: #5fbeb5 !important; height: 50px;
        font-size: 16px;" (click)="addSon()">
            <mat-icon>person_add</mat-icon>
            &nbsp; {{ 'inputs.add_son' | translate }}
        </button>
    </div>
</div>
